import {Profession} from '../app/shared/models/lookup-profession.model';

const mockProfessions: Profession[] = [{
  id: 1,
  name: 'Registered Nurse',
  typeId: 1,
  abbreviation: 'RN',
  professionType: null
}, {
  id: 2,
  name: 'LVN / LPN',
  typeId: 1,
  abbreviation: 'LVN',
  professionType: null
}, {
  id: 3,
  name: 'Nurse Practitioner',
  typeId: 4,
  abbreviation: 'NP',
  professionType: null
}, {
  id: 5,
  name: 'CNA / Nurse Assistant',
  typeId: 1,
  abbreviation: 'CNA',
  professionType: null
}, {
  id: 12,
  name: 'Radiology / Cardiology',
  typeId: 2,
  abbreviation: 'RAD-CARD',
  professionType: null
}, {
  id: 13,
  name: 'Respiratory / Neuro Diagnostics',
  typeId: 2,
  abbreviation: 'RESP',
  professionType: null
}, {
  id: 15,
  name: 'Speech Language Pathologist (SLP)',
  typeId: 2,
  abbreviation: 'SLP',
  professionType: null
}, {
  id: 16,
  name: 'Occupational Therapist',
  typeId: 2,
  abbreviation: 'OT',
  professionType: null
}, {
  id: 17,
  name: 'Physical Therapist',
  typeId: 2,
  abbreviation: 'PT',
  professionType: null
}, {
  id: 19,
  name: 'Cytotechnologist',
  typeId: 2,
  abbreviation: 'CYTO',
  professionType: null
}, {
  id: 20,
  name: 'Pharmacy',
  typeId: 2,
  abbreviation: 'PHM',
  professionType: null
}, {
  id: 22,
  name: 'EMT',
  typeId: 2,
  abbreviation: 'EMT',
  professionType: null
}, {
  id: 23,
  name: 'Manager / Director',
  typeId: 1,
  abbreviation: 'MGMT',
  professionType: null
}, {
  id: 24,
  name: 'Non-Clinical - Legal',
  typeId: 3,
  abbreviation: 'LGL',
  professionType: null
}, {
  id: 25,
  name: 'Certified Occupational Therapist Assistant (COTA)',
  typeId: 2,
  abbreviation: 'COTA',
  professionType: null
}, {
  id: 26,
  name: 'Physical Therapist Assistant (PTA)',
  typeId: 2,
  abbreviation: 'PTA',
  professionType: null
}, {
  id: 29,
  name: 'Social Worker',
  typeId: 2,
  abbreviation: 'SW',
  professionType: null
}, {
  id: 30,
  name: 'Behavioral Health Tech',
  typeId: 2,
  abbreviation: 'BHT',
  professionType: null
}, {
  id: 31,
  name: 'Speech Language Pathologist Assistant',
  typeId: 2,
  abbreviation: 'SLPA',
  professionType: null
}, {
  id: 37,
  name: 'Dialysis Tech',
  typeId: 2,
  abbreviation: 'DT',
  professionType: null
}, {
  id: 39,
  name: 'Certified Anesthesia Technician',
  typeId: 2,
  abbreviation: 'CAT',
  professionType: null
}, {
  id: 40,
  name: 'Medical Coder',
  typeId: 3,
  abbreviation: 'MC',
  professionType: null
}, {
  id: 42,
  name: 'MHT',
  typeId: 2,
  abbreviation: 'MHT',
  professionType: null
}, {
  id: 43,
  name: 'Paramedic',
  typeId: 2,
  abbreviation: 'PMDC',
  professionType: null
}, {
  id: 46,
  name: 'Audiologist',
  typeId: 2,
  abbreviation: 'ADST',
  professionType: null
}, {
  id: 47,
  name: 'Clinical Psychologist',
  typeId: 2,
  abbreviation: 'CPS',
  professionType: null
}, {
  id: 49,
  name: 'Trained Medication Assistant',
  typeId: 2,
  abbreviation: 'TMA',
  professionType: null
}, {
  id: 55,
  name: 'Non-Clinical',
  typeId: 3,
  abbreviation: 'NONCLIN',
  professionType: null
}, {
  id: 56,
  name: 'Physicist',
  typeId: 2,
  abbreviation: 'PHYS',
  professionType: null
}, {
  id: 57,
  name: 'Patient Care Technician',
  typeId: 2,
  abbreviation: 'PCT',
  professionType: null
}, {
  id: 59,
  name: 'Physician',
  typeId: 4,
  abbreviation: 'MD',
  professionType: null
}, {
  id: 60,
  name: 'Non-Clinical - Administrative',
  typeId: 3,
  abbreviation: 'ADMIN',
  professionType: null
}, {
  id: 61,
  name: 'Sports Medicine',
  typeId: 2,
  abbreviation: 'SPORT',
  professionType: null
}, {
  id: 62,
  name: 'Ophthalmology',
  typeId: 2,
  abbreviation: 'OPTH',
  professionType: null
}, {
  id: 63,
  name: 'Perfusionist',
  typeId: 2,
  abbreviation: 'PERF',
  professionType: null
}, {
  id: 64,
  name: 'Laboratory',
  typeId: 2,
  abbreviation: 'LAB',
  professionType: null
}, {
  id: 65,
  name: 'Medical Assistant',
  typeId: 2,
  abbreviation: 'MA',
  professionType: null
}, {
  id: 66,
  name: 'Sitter',
  typeId: 1,
  abbreviation: 'SITTER',
  professionType: null
}, {
  id: 67,
  name: 'Certified Child Life Specialist',
  typeId: 2,
  abbreviation: 'CLS',
  professionType: null
}, {
  id: 68,
  name: 'Behavioral Health Assistant',
  typeId: 3,
  abbreviation: 'BHA',
  professionType: null
}, {
  id: 69,
  name: 'Surgical Services',
  typeId: 1,
  abbreviation: 'SURG',
  professionType: null
}, {
  id: 70,
  name: 'Dietician',
  typeId: 2,
  abbreviation: 'DIET',
  professionType: null
}, {
  id: 71,
  name: 'Midwife',
  typeId: 2,
  abbreviation: 'MIDWIFE',
  professionType: null
}, {
  id: 72,
  name: 'Physician Assistant',
  typeId: 4,
  abbreviation: 'PA',
  professionType: null
}, {
  id: 73,
  name: 'Certified Registered Nurse Anesthetist (CRNA)',
  typeId: 4,
  abbreviation: 'CRNA',
  professionType: null
}, {
  id: 74,
  name: 'ER Tech',
  typeId: 2,
  abbreviation: 'ER-TECH',
  professionType: null
}, {
  id: 75,
  name: 'Ancillary Support Services',
  typeId: 1,
  abbreviation: 'Anc-SS',
  professionType: null
}, {
  id: 76,
  name: 'Non-Clinical - Transportation/Logistics',
  typeId: 3,
  abbreviation: 'TRN-LOG',
  professionType: null
}, {
  id: 77,
  name: 'Non-Clinical - Health and Information Management',
  typeId: 3,
  abbreviation: 'HIM',
  professionType: null
}, {
  id: 78,
  name: 'Non-Clinical - Information Technology',
  typeId: 3,
  abbreviation: 'IT',
  professionType: null
}, {
  id: 79,
  name: 'Environmental Services',
  typeId: 3,
  abbreviation: 'EVS',
  professionType: null
}, {
  id: 80,
  name: 'Facilities',
  typeId: 3,
  abbreviation: 'Facilities',
  professionType: null
}, {
  id: 81,
  name: 'Finance/Accounting',
  typeId: 3,
  abbreviation: 'Fin-Acctg',
  professionType: null
}, {
  id: 82,
  name: 'Food and Nutrition Services',
  typeId: 3,
  abbreviation: 'FNS',
  professionType: null
}, {
  id: 83,
  name: 'Human Resources',
  typeId: 3,
  abbreviation: 'HR',
  professionType: null
}, {
  id: 84,
  name: 'Non-Clinical - Marketing',
  typeId: 3,
  abbreviation: 'MKTG',
  professionType: null
}, {
  id: 85,
  name: 'Non-Clinical - Security',
  typeId: 3,
  abbreviation: 'SEC',
  professionType: null
}, {
  id: 86,
  name: 'Non-Clinical - Environmental Services',
  typeId: 3,
  abbreviation: 'EVS',
  professionType: null
}, {
  id: 87,
  name: 'Non-Clinical - Facilities',
  typeId: 3,
  abbreviation: 'FAC',
  professionType: null
}, {
  id: 88,
  name: 'Non-Clinical - Finance/Accounting',
  typeId: 3,
  abbreviation: 'FIN/ACC',
  professionType: null
}, {
  id: 89,
  name: 'Non-Clinical - Food and Nutrition Services',
  typeId: 3,
  abbreviation: 'FNS',
  professionType: null
}, {
  id: 90,
  name: 'Non-Clinical - Human Resources',
  typeId: 3,
  abbreviation: 'HR',
  professionType: null
}];
export default mockProfessions;
